<template>
  <v-app id="app">
    <v-toolbar>
      <v-toolbar-title><img src="@/assets/logo2.png"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn href="revista.html" target="_blank" flat>Revista</v-btn>
        <v-btn @click.native="ventanaComprobante" flat>Consultar comprobante</v-btn>
        <v-btn @click.native="ventanaContacto" flat>Contacto</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-alert
          :value="mensajeEnviado"
          dismissible
          type="success"
        >
          Mensaje enviado
        </v-alert>
        <v-layout>
          <v-flex xs12>
              <v-layout wrap>
                <v-flex xs12 v-if="1 == 2">
                  <v-combobox
                    v-model="ciudad"
                    :items="ciudades"
                    label="Seleccione una ciudad"
                  ></v-combobox>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center align-end style="margin: 80px">
                <v-flex xs12><center><h2>Revista</h2></center></v-flex>
                <v-flex xs12>
                  <center><br />
                  <a href="revista.html" target="_blank"><img :src="inicio.imgRevista" titles="Revista" width="141" height="200" /></a>
                  </center>
                </v-flex>
                <v-flex xs2></v-flex>
              </v-layout>
              <v-layout wrap style="margin: 40px">
                <v-flex xs12><center><h2>Pagos</h2></center></v-flex><br /><br /><br />
                <v-flex xs12><center><h3>Tumbes - Zarumilla - Olmos</h3></center></v-flex><br /><br />
                <v-flex xs12>
                  <v-flex xs12><center><h3>&nbsp;</h3></center></v-flex>
                  <v-flex xs12><center><a href="http://agentekasnet.com/" target="_blank"><img src="@/assets/kasnet2.png" width="250em"/></a></center></v-flex>
                  <v-flex xs12><center>Paga tus servicios con el código de empresa: 190595</center></v-flex>
                  <v-flex xs12><center><h5>* Comisión S/1.00</h5></center></v-flex>
                </v-flex>
              </v-layout>
              <v-layout wrap style="margin: 40px">
                <v-flex xs12><center><h3>Ayacucho - Chepén - Guadalupe - Ferreñafe - Pacasmayo - Tumán - Trujillo</h3></center></v-flex><br /><br />
                <v-flex xs6>
                  <v-flex xs12><center><h3>&nbsp;</h3></center></v-flex>
                  <v-flex xs12><center><a href="http://agentekasnet.com/" target="_blank"><img src="@/assets/kasnet2.png" width="250em"/></a></center></v-flex>
                  <v-flex xs12><center>Paga tus servicios con el código de empresa: 190598</center></v-flex>
                  <v-flex xs12><center><h5>* Comisión S/1.00</h5></center></v-flex>
                </v-flex>
                <v-flex xs6>
                  <v-flex xs12><center><h3>&nbsp;</h3></center></v-flex>
                  <v-flex xs12><center><a href="http://agentekasnet.com/" target="_blank"><img src="@/assets/yapejyf.jpg" width="130em"/></a></center></v-flex>
                  <v-flex xs12><center>Paga con Yape escanenado el QR</center></v-flex>
                  <v-flex xs12><center><h5><a target="_blank" href="https://www.youtube.com/watch?v=dh_i_D8r5XM">Tutorial como yapear</a></h5></center></v-flex>
                </v-flex>
              </v-layout>
              <v-layout wrap style="margin: 40px">
                <v-flex xs12><center><h3>Huánuco - Tingo María - La Merced</h3></center></v-flex><br /><br />
                <v-flex xs6>
                  <v-flex xs12><center><h3>&nbsp;</h3></center></v-flex>
                  <v-flex xs12><center><a href="http://agentekasnet.com/" target="_blank"><img src="@/assets/kasnet2.png" width="250em"/></a></center></v-flex>
                  <v-flex xs12><center>Paga tus servicios con el código de empresa: 190597</center></v-flex>
                  <v-flex xs12><center><h5>* Comisión S/1.00</h5></center></v-flex>
                </v-flex>
                <v-flex xs6>
                  <v-flex xs12><center><h3>&nbsp;</h3></center></v-flex>
                  <v-flex xs12><center><a href="http://agentekasnet.com/" target="_blank"><img src="@/assets/yapehuanuco.jpg" width="130em"/></a></center></v-flex>
                  <v-flex xs12><center>Paga con Yape escanenado el QR</center></v-flex>
                  <v-flex xs12><center><h5><a target="_blank" href="https://www.youtube.com/watch?v=dh_i_D8r5XM">Tutorial como yapear</a></h5></center></v-flex>
                </v-flex>
              </v-layout>
              <v-layout wrap style="margin: 40px">
                <v-flex xs12><center><h3>Loreto</h3></center></v-flex><br /><br />
                <v-flex xs12>
                  <v-flex xs12><center><h3>&nbsp;</h3></center></v-flex>
                  <v-flex xs12><center><a href="http://agentekasnet.com/" target="_blank"><img src="@/assets/kasnet2.png" width="250em"/></a></center></v-flex>
                  <v-flex xs12><center>Paga tus servicios con el código de empresa: 190596</center></v-flex>
                  <v-flex xs12><center><h5>* Comisión S/1.00</h5></center></v-flex>
                </v-flex>
              </v-layout>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <br />
        <br />
      </v-container>
    </v-content>
    <v-dialog v-model="vContacto" width="500">
      <v-card>
        <v-container>
          <form>
            <v-text-field
              label="Nombre"
              v-model="contacto.nombre"
              required
            ></v-text-field>
            <v-text-field
              label="Correo electrónico"
              v-model="contacto.email"
            ></v-text-field>
            <v-text-field
              label="Teléfono"
              v-model="contacto.telefono"
            ></v-text-field>
            <v-select
              v-model="contacto.ciudad"
              :items="ciudades"
              label="Ciudad"
              required
            ></v-select>
            <v-textarea
              label="Mensaje"
              v-model="contacto.mensaje"
              value=""
            ></v-textarea>
            <v-btn @click="enviarContacto" :disabled="computedContacto">Enviar</v-btn>
          </form>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vComprobantes" max-width="40%">
      <v-card v-if="!mostrarComprobante">
        <v-card-title>
          <span class="headline">Consultar comprobante electrónico</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 lg12 d-flex>
                <v-select
                :items="empresas"
                item-text="value"
                item-value="id"
                label="Empresa"
                :messages="errores.empresa.mensajes"
                :error="errores.empresa.error"
                v-model="registro.empresa"
              ></v-select>
              </v-flex>
              <v-flex xs12 sm12 lg12 d-flex>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  :return-value.sync="registro.fecha"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="fecha"
                    label="Fecha"
                    @blur="registro.fecha = parseDate(fecha)"
                    :messages="errores.fecha.mensajes"
                    :error="errores.fecha.error"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="registro.fecha" locale='es-pe' @input="$refs.menu.save(registro.fecha)" scrollable></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 sm3 lg2 d-flex>
                <v-text-field label="Serie" maxlength=4 v-model="registro.serie" :messages="errores.serie.mensajes" :error="errores.serie.error" v-on:keyup="registro.serie = registro.serie.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 lg2 d-flex>
                <v-text-field label="Número" mask="#######" v-model="registro.numero" :messages="errores.numero.mensajes" :error="errores.numero.error"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 lg12 d-flex>
                <v-text-field label="Monto" v-model="registro.monto" :messages="errores.monto.mensajes" :error="errores.monto.error" v-money></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark round @click.native="buscarComprobante">Buscar</v-btn>
          <v-btn color="primary" dark round @click.native="cerrarComprobante">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="mostrarComprobante">
        <v-card-title>
          <span class="headline">Consultar comprobante electrónico</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-layout row wrap>
                <v-flex xs2><b>Código</b></v-flex>
                <v-flex xs2><b>Comprobante</b></v-flex>
                <v-flex xs2><b>F. emisión</b></v-flex>
                <v-flex xs2><b>Monto</b></v-flex>
                <v-flex xs2><b>F. cancelación</b></v-flex>
                <v-flex xs2><b>Descargar</b></v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs2>{{ comprobante.abonado }}</v-flex>
                <v-flex xs2>{{ comprobante.numero }}</v-flex>
                <v-flex xs2>{{ comprobante.emision }}</v-flex>
                <v-flex xs2>{{ comprobante.monto }}</v-flex>
                <v-flex xs2>{{ comprobante.cancelacion }}</v-flex>
                <v-flex xs2><a href="#" @click="imprimir">PDF</a> <a :download="nombreArchivo" :href="zip">XML</a></v-flex>
              </v-layout>
              <v-flex xs12>
                <v-card>
                  <v-card-title>
                    <span class="headline">Deuda</span>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex><b>Código</b></v-flex>
                      <v-flex><b>Concepto</b></v-flex>
                      <v-flex><b>Moneda</b></v-flex>
                      <v-flex><b>Monto</b></v-flex>
                    </v-layout>
                    <v-layout row wrap v-for="deuda in deudas" v-bind:key="deuda.abonado">
                      <v-flex>{{ deuda.abonado }}</v-flex>
                      <v-flex>{{ deuda.concepto }}</v-flex>
                      <v-flex>{{ deuda.moneda }}</v-flex>
                      <v-flex>{{ comprobante.monto }}</v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark round @click.native="cerrarComprobante">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from 'pdfmake/build/vfs_fonts.js'
export default {
  name: 'app',
  data: () => ({
    vContacto: false,
    vComprobantes: false,
    mensajeEnviado: false,
    fecha: '',
    zip: '#',
    nombreArchivo: 'comprobante.zip',
    mostrarComprobante: false,
    menu: false,
    comprobante: {},
    contacto: {},
    deudas: [],
    inicio: {imgRevista: ''},
    ciudad: '',
    ciudades: [
      'Ayacucho',
      'Chepén',
      'Ferreñafe',
      'Guadalupe',
      'Huánuco',
      'Iquitos',
      'La Merced',
      'Olmos',
      'Tingo María',
      'Tumán',
      'Tumbes',
      'Trujillo',
      'Zarumilla'
    ],
    empresas: [
      {id: '20479514616', value: 'CABLENORTV S.A.C.'},
      {id: '20482177531', value: 'COMUNICACIONES J&F CABLE TV S.A.C.'},
      {id: '20567215092', value: 'CABLE VISION LORETO S.A.C.'}
    ],
    registro: {
      empresa: '',
      fecha: '',
      numero: '',
      serie: '',
      monto: ''
    },
    errores: {
      empresa: {mensajes: [], error: false},
      fecha: {mensajes: [], error: false},
      numero: {mensajes: [], error: false},
      serie: {mensajes: [], error: false},
      monto: {mensajes: [], error: false}
    }
  }),
  computed: {
    computedFecha () {
      return this.formatoFecha(this.comprobanteFecha)
    },
    computedContacto () {
      if (this.contacto.nombre !== undefined && this.contacto.ciudad !== undefined && this.contacto.mensaje !== undefined) {
        return false
      }
      return true
    }
  },
  watch: {
    'registro.fecha' (val) {
      this.fecha = this.formatoFecha(this.registro.fecha)
    }
  },
  beforeMount () {
    const myRequest = new Request(`inicio.js`, {method: 'GET', headers: new Headers({'Content-Type': 'application/json; charset=UTF-8'})})
    return fetch(
      myRequest
    )
      .then(response => response.json())
      .then(datos => {
        this.inicio = datos.inicio
      })
  },
  methods: {
    formatoFecha (fecha) {
      if (!fecha) return null
      fecha = fecha.substr(0, 10)
      const [year, month, day] = fecha.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (fecha) {
      if (!fecha) return null
      const [day, month, year] = fecha.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    ventanaComprobante () {
      this.registro = {
        empresa: '',
        fecha: new Date().toISOString().substr(0, 10),
        numero: '',
        serie: '',
        monto: ''
      }
      this.mostrarComprobante = false
      this.vComprobantes = true
    },
    ventanaContacto () {
      this.vContacto = true
    },
    enviarContacto () {
      const myRequest = new Request(`contacto.php`, {method: 'POST', body: JSON.stringify(this.contacto), headers: new Headers({'Content-Type': 'application/json; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          console.log(datos)
          if (datos.error === 0) {
          }
          this.vContacto = false
          this.contacto = {}
          this.mensajeEnviado = true
        })
    },
    cerrarComprobante () {
      this.vComprobantes = false
      this.mostrarComprobante = false
    },
    buscarComprobante () {
      const myRequest = new Request(`${process.env.NODE_API}prod?serie=${this.registro.serie}&numero=${this.registro.numero}&monto=${this.registro.monto}&fecha=${this.registro.fecha}&empresa=${this.registro.empresa}`, {method: 'GET', headers: new Headers({'Content-Type': 'application/json; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.error === 0) {
            this.comprobante = datos.data.comprobante
            this.deudas = datos.data.deudas
            this.mostrarComprobante = true
            this.zip = 'data:application/zip;base64,' + this.comprobante.zip
            this.nombreArchivo = this.registro.serie + '-' + this.registro.numero + '.zip'
          }
        })
    },
    imprimir () {
      var win = window.open('', '_blank')
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(JSON.parse(this.comprobante.pdf)).open({}, win)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue